<template>
  <va-form :id="id" :item="item" disable-redirect @saved="$emit('saved')">
    <v-card-text>
      <va-text-input
        source="description"
        required
        taggable
        multiline
      ></va-text-input>
      <va-text-input
        source="areaCode"
        required
        taggable
        multiline
      ></va-text-input>
    </v-card-text>
    <va-save-button label="Salvar"></va-save-button>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
